import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-29809b8f"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "custom-control custom-checkbox"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
  const _component_app_popover = _resolveComponent("app-popover");
  const _component_app_td = _resolveComponent("app-td");
  return _openBlock(), _createBlock(_component_app_td, {
    align: "center",
    stickyColumn: "true",
    style: {
      left: '0px'
    }
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_b_form_checkbox, {
      class: "custom-control-input",
      disabled: $props.disabled,
      id: 'checkbox' + $props.item.content_id,
      checked: $props.isSelectedItem,
      onChange: _cache[0] || (_cache[0] = $event => _ctx.$emit('selectItem', {
        $event,
        item: $props.item
      }))
    }, null, 8, ["disabled", "id", "checked"])]), _createVNode(_component_app_popover, {
      target: 'checkbox' + $props.item.content_id
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString($props.disabled ? "No updates to push" : "Select updated rows"), 1)]),
      _: 1
    }, 8, ["target"])]),
    _: 1
  });
}